/* VIEWS */

import Login from '@/views/Login'
import ForgotPassword from '@/views/ForgotPassword'
import Layout from '@/views/Layout'
import Home from '@/views/Home'
import ProductManual from '@/views/ProductManual'
import Article from '@/views/Article'
import Questions from '@/views/Questions'
import SearchResults from '@/views/SearchResults'
import ControlPanel from '@/views/ControlPanel'
import Products from '@/views/Products'
import Settings from '@/views/Settings'
import Users from '@/views/Users'
import MyAccount from '@/views/MyAccount'
import ForbiddenError from '@/views/ForbiddenError'
import NotFoundError from '@/views/NotFoundError'

/* ROUTES */

export default [
  // Auth
  { path: '/', name: 'login', component: Login, meta: { auth: false } },
  { path: '/esqueci-minha-senha', name: 'forgot-password', component: ForgotPassword, meta: { auth: false } },
  {
    path: '/app',
    component: Layout,
    meta: { auth: true },
    children: [
      // Home
      { path: '', name: 'home', component: Home },
      // Manuals
      {
        path: 'manual/:product',
        component: ProductManual,
        children: [
          { path: '', name: 'manual', component: Questions },
          {
            path: 'nova-pergunta',
            name: 'new-question',
            component: Questions,
            meta: { auth: { roles: ['admin', 'support'] } } },
          {
            path: 'novo-artigo',
            name: 'new-article',
            component: Article,
            meta: { auth: { roles: ['admin', 'support'] } }
          },
          {
            path: 'editar-artigo/:article',
            name: 'edit-article',
            component: Article,
            meta: { auth: { roles: ['admin', 'support'] } }
          },
          { path: ':article', name: 'article', component: Article }
        ]
      },
      // Search
      { path: 'resultado-da-pesquisa', name: 'search', component: SearchResults },
      // Painel de Controle
      {
        path: 'painel-de-controle',
        component: ControlPanel,
        meta: { auth: { roles: ['admin', 'support'] } },
        children: [
          // Settings
          { path: 'configuracoes', name: 'settings', component: Settings, meta: { auth: { roles: 'admin' } } },
          // Users
          {
            path: 'usuarios',
            name: 'users',
            component: Users,
            meta: { auth: { roles: ['admin', 'support'] } },
            children: [
              { path: 'adicionar', name: 'users-create', component: Users },
              { path: 'editar/:user', name: 'users-edit', component: Users }
            ]
          },
          // Products
          {
            path: 'produtos',
            name: 'products',
            component: Products,
            meta: { auth: { roles: 'admin' } },
            children: [
              { path: 'adicionar', name: 'products-create', component: Products },
              { path: 'editar/:product', name: 'products-edit', component: Products }
            ]
          }
        ]
      },
      // Minha Conta
      { path: 'minha-conta', name: 'my-account', component: MyAccount }
    ]
  },
  { path: '/403', name: '403-error', component: ForbiddenError },
  { path: '*', name: '404-error', component: NotFoundError }
]
